import {
  SAVE_QUOTEID,
  UPDATE_QUOTEID_AUTHTOKEN,
  UPDATE_QUOTEID_AUTHTOKEN_ERROR,
  UPDATE_QUOTEDETAILS,
  CLEAR_AUTH_ERROR,
} from './actionTypes';
import { Auth } from '../services';

const auth = new Auth();

export const saveQuoteId = (quoteId) => ({
  type: SAVE_QUOTEID,
  payload: quoteId,
});

export const updateAuthtokenSuccess = (authtoken) => ({
  type: UPDATE_QUOTEID_AUTHTOKEN,
  payload: authtoken,
});

export const updateAuthtokenError = (errorMessage) => ({
  type: UPDATE_QUOTEID_AUTHTOKEN_ERROR,
  payload: errorMessage,
});

export const updateQuote = (quotedata) => ({
  type: UPDATE_QUOTEDETAILS,
  payload: quotedata,
});

export const updateQuoteIdAuthtoken = (quoteZipdata) => async (dispatch) => {
  try {
    const authResponse = await auth.fetchAuth(quoteZipdata);
    const quoteData = await auth.fetchQuoteData(
      quoteZipdata.quoteId,
      authResponse.token,
    );
    dispatch(
      updateAuthtokenSuccess({
        authToken: authResponse.token,
        quoteDetails: quoteData,
      }),
    );
  } catch (err) {
    console.error('[updateQuoteIdAuthtoken]', err);
    dispatch(updateAuthtokenError('Unauthorized'));
  }
};

export const updateAuthforQuote = (quoteId, zipCode) => async (dispatch) => {
  try {
    const authResponse = await auth.fetchAuth({ quoteId, zipCode });
    const quoteData = await auth.fetchQuoteData(quoteId, authResponse.token);
    dispatch(
      updateAuthtokenSuccess({
        authToken: authResponse.token,
        quoteDetails: quoteData,
      }),
    );
    return authResponse;
  } catch (err) {
    dispatch(updateAuthtokenError(err));
  }
};

export const checkValidation = () => async (dispatch) => {
  dispatch(updateAuthtokenSuccess({ authToken: null }));
};

export const clearAuthError = () => ({ type: CLEAR_AUTH_ERROR });
